export class EnumLabels {}
EnumLabels.CANCEL_AND_GOBACK_MERCHANT = "Cancel and Go Back to Merchant";
EnumLabels.CANCEL_AND_GOBACK_STORE = "Cancel and Go Back to Store";
EnumLabels.CANCEL_AND_GOBACK_LAZADA = "Cancel and Go Back to Lazada";
EnumLabels.ENTER_MOBILE_NUM = "Enter your mobile number";
EnumLabels.MOBILE_HINT = "Login with your registered mobile number in the Home Credit app";
EnumLabels.ENTR_YOUR_PIN = "Enter your PIN";
EnumLabels.PIN_HINT = "Login with your Home Credit app PIN";
EnumLabels.STEP_1 = "Log in to the Home Credit app with your mobile number and PIN";
EnumLabels.STEP_2 = "Tap 'Review now' to authorize your payment request";
EnumLabels.CANCEL = "Cancel";
EnumLabels.CONTINUE = "Continue";
EnumLabels.TRYAGAIN = "Try again";
EnumLabels.DOWNLOADON = "Download on";
EnumLabels.APPSTORE = "App Store";
EnumLabels.PLAYSTORE = "Play Store";
EnumLabels.APPGALLERY = "App Gallery";
EnumLabels.CONTINUE_WITH_MOBILE_NO = "Continue with Mobile No.";
EnumLabels.CONTINUE_TO_PAYMENT = "Continue to Payment";
EnumLabels.BUY_NOW = "Buy now, pay later! Start your Home Credit loan application via chat";
EnumLabels.OUR_HOME = "Our Home Credit loan specialists are here to help";

Object.freeze(EnumLabels);